<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1">
        <a ngbNavLink><i class="fa-brands fa-whatsapp text-success"></i> Whatsapp</a>
        <ng-template ngbNavContent>
            <app-share-whatsapp></app-share-whatsapp>
        </ng-template>
    </li>
    <li [ngbNavItem]="2">
        <a ngbNavLink><i class="fa-solid fa-envelope"></i> Email</a>
        <ng-template ngbNavContent>


        </ng-template>
    </li>
    <li [ngbNavItem]="3">
        <a ngbNavLink><i class="fa-solid fa-download"></i> Descargar</a>
        <ng-template ngbNavContent>



        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>